import { useEffect } from 'react';
import { Card } from '../ui/Card.jsx';
import { Button } from '../ui/Button.jsx';
import { useAudio } from '../../hooks/useAudio.js';

export function CombatCard({ result, onContinue }) {
  const audio = useAudio();
  const { raidStrength, defense, won, damage, losses } = result;

  // Play combat sounds
  useEffect(() => {
    if (result) {
      audio.playSound('combat_warcry');

      // Play victory/defeat sound after a brief delay
      const timer = setTimeout(() => {
        audio.playSound(won ? 'music_jingle_positive' : 'ui_negative');
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [result, won, audio]);

  return (
    <Card title="Raid!" icon="⚔️">
      <div className="text-center mb-6">
        <div className="flex justify-around mb-4">
          <div>
            <div className="text-3xl mb-1">🏴</div>
            <div className="text-sm text-amber-700">Raiders</div>
            <div className="text-2xl font-bold text-red-700">{raidStrength}</div>
          </div>
          <div className="text-3xl self-center">⚔️</div>
          <div>
            <div className="text-3xl mb-1">🛡️</div>
            <div className="text-sm text-amber-700">Defense</div>
            <div className="text-2xl font-bold text-green-700">{defense}</div>
          </div>
        </div>
        <div className={`text-xl font-bold ${won ? 'text-green-700' : 'text-red-700'}`}>
          {won ? '✨ Raiders Repelled!' : `💥 ${damage} damage!`}
        </div>
        {!won && losses && (
          <p className="text-amber-700 mt-2">
            Lost: {losses.food > 0 && `${losses.food} food `}
            {losses.wood > 0 && `${losses.wood} wood `}
            {losses.stone > 0 && `${losses.stone} stone `}
            {losses.workerInjured && '⚠️ Worker injured!'}
          </p>
        )}
      </div>
      <div className="text-center">
        <Button onClick={onContinue}>Continue</Button>
      </div>
    </Card>
  );
}
